import { useRecoilValue } from 'recoil'
import { roleAtom } from '@/atoms/globalAtoms'
import { userAtom } from '@/atoms/_globalAtoms'
import { EDITOR_USER_ROLE, userTypes } from '@messenger/consts'

/**
 * Whether the signed-in user is internal staff: the messenger-user role (a
 * super admin, or a designer or QC edit session) or the super-admin type.
 * Narrower than `useIsAdmin`, which also admits corporation admins and users
 * acting as admin. It gates the editor's staff-only controls, such as the new
 * text boxes switch, in the UI only; the server does not check it.
 */
export const useIsInternalAdmin = (): boolean => {
  const userRole = useRecoilValue(roleAtom)
  const user = useRecoilValue(userAtom)
  return (
    userRole === EDITOR_USER_ROLE.MESSENGER ||
    user?.type === userTypes.superAdmin
  )
}
